import React from "react";
import { Box, Typography } from "@mui/material";

export default function FptsStatsSummary({ fptsStats }) {
  if (!fptsStats) return null;

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: "#f5f5f5",
        borderRadius: 1,
        height: 400,
      }}
    >
      <Typography variant="h6" sx={{ mb: 3 }}>
        FPTS Statistics Summary
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Total Lineups
        </Typography>
        <Typography variant="h4" color="primary">
          {fptsStats.totalLineups}
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          FPTS Ranges
        </Typography>
        <Typography variant="h5">{fptsStats.summary.totalRanges}</Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Avg per Range
        </Typography>
        <Typography variant="h5">
          {fptsStats.summary.averageLineupsPerRange}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{ mt: 3, fontStyle: "italic", color: "text.secondary" }}
      >
        📊 This chart shows the distribution of lineups across different FPTS
        performance ranges
      </Typography>
    </Box>
  );
}
